import axios from "@/api/axiosInstance";
import { GetCourseMetadataResponse } from "./types";

export const getCourseMetadata =
  async (): Promise<GetCourseMetadataResponse> => {
    const response = await axios.get<GetCourseMetadataResponse>(
      "/api/private/learning-center/courses/metadata",
    );
    return response.data;
  };
